exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a03aaf00","scoped":false,"hasInlineConfig":false}!./src/ciao-vue-popup/dist/ciao-vue-popup.css
// module id = TbG6
// module chunks = 1